import { FastField } from 'formik';
import React, { useState, useEffect } from 'react';
import PersonalError from './PersonalError';
import jMoment from "moment-jalaali";

const months = [
  { id: "1", value: "فروردین" },
  { id: "2", value: "اردیبهشت" },
  { id: "3", value: "خرداد" },
  { id: "4", value: "تیر" },
  { id: "5", value: "مرداد" },
  { id: "6", value: "شهریور" },
  { id: "7", value: "مهر" },
  { id: "8", value: "آبان" },
  { id: "9", value: "آذر" },
  { id: "10", value: "دی" },
  { id: "11", value: "بهمن" },
  { id: "12", value: "اسفند" }
];

const Date = ({ name, icon, formik, placeholder, direction }) => {
  const [day, setDay] = useState("1");
  const [month, setMonth] = useState("1");
  const [selectedYear, setSelectedYear] = useState("");
  const [yearOptions, setYearOptions] = useState([]);
  const [daysInMonth, setDaysInMonth] = useState([]);

  useEffect(() => {
    const moment = jMoment();
    const currentYear = moment.jYear();

    setDay(moment.jDate().toString());
    setMonth((moment.jMonth()  ).toString());
    setSelectedYear((currentYear-30).toString());

    const yearsArray = [];
    for (let i = currentYear - 100; i <= currentYear + 100; i++) {
      yearsArray.push(i.toString());
    }
    setYearOptions(yearsArray);
    
  }, []);

  useEffect(() => {
    if (!day || !month || !selectedYear) return;
  
    const totalDays = jMoment.jDaysInMonth(Number(selectedYear), Number(month));
    const daysArray = Array.from({ length: totalDays }, (_, i) => (i + 1).toString());
    setDaysInMonth(daysArray);
  
    if (Number(day) > totalDays) {
      setDay("1");
    }
  
    const formattedDate = `${selectedYear}/${String(month).padStart(2, '0')}/${String(day).padStart(2, '0')}`;
    formik.setFieldValue(name, formattedDate);
    console.log(`${name}`, formik.values[name]);
  }, [day, month, selectedYear]);
  
  useEffect(() => {
    console.log("Updated value:", formik.values[name]);
  }, [formik.values[name]]);
  
  

  return (
    <div className="form-group icon-group position-relative">
      <input
        type="text"
        className="form-control"
        id={name}
        placeholder={placeholder}
        dir={direction}
        readOnly
      />
      <span className="icon-inside">
        <i className={icon}></i>
      </span>

      <div className="position-absolute d-flex justify-content-center date-container">
        <select value={day} onChange={(e) => setDay(e.target.value)}>
          {daysInMonth.map(d => (
            <option key={d} value={d}>{d}</option>
          ))}
        </select>

        <select value={month} onChange={(e) => setMonth(e.target.value)}>
          {months.map(m => (
            <option key={m.id} value={m.id}>{m.value}</option>
          ))}
        </select>

        <select value={selectedYear} onChange={(e) => setSelectedYear(e.target.value)}>
          {yearOptions.map(y => (
            <option key={y} value={y}>{y}</option>
          ))}
        </select>
      </div>

      {/* <PersonalError
        errors={formik.errors}
        touched={formik.touched}
        name={name}
      /> */}
    </div>
  );
};

export default Date;
